import React from 'react';
import CountUp from 'react-countup';

const Counter = () => {
    return(
        <>
            {/*Counter Section*/}
            <section className="counter-section section-padding-five">
                <div className="default-container">
                <div className="row clearfix">
                    <div className="col-lg-12">
                    <div className="sec-o-title text-center pb-3">
                        <h2 className="transform-uppercase">OUR <span>SUCCESS</span></h2>
                    </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-3">
                    <div className="inner text-center">
                        <div className="content">
                        <i className="flaticon-correct" />
                        <div className="count-outer count-box">
                            <span className="count-text"><CountUp start={0} end={432}></CountUp></span>
                        </div>
                        <h4 className="counter-title">Qualified Lawyers</h4>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-3">
                    <div className="inner text-center">
                        <div className="content">
                        <i className="flaticon-grinning" />
                        <div className="count-outer count-box alternate">
                            <span className="count-text"><CountUp start={0} end={543}></CountUp></span>
                        </div>
                        <h4 className="counter-title">Trusted Clients</h4>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-3">
                    <div className="inner text-center">
                        <div className="content">
                        <i className="flaticon-thumbs-up-hand-symbol" />
                        <div className="count-outer count-box alternate">
                            <span className="count-text"><CountUp start={0} end={253}></CountUp></span>
                        </div>
                        <h4 className="counter-title">Successful Cases</h4>
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-3">
                    <div className="inner text-center">
                        <div className="content">
                        <i className="flaticon-tree-leaf" />
                        <div className="count-outer count-box">
                            <span className="count-text"><CountUp start={0} end={275}></CountUp></span>
                        </div>
                        <h4 className="counter-title">Honors &amp; Awards</h4>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </section>
            {/*End Counter Section*/}
        </>
    )
}

export default Counter;